import { MutableRefObject, useEffect } from 'react';

export type TOnOutsideClickHandler = (event: MouseEvent | TouchEvent) => void;

export function useOutsideClick<T extends HTMLDivElement | null = HTMLDivElement>(
  ref: MutableRefObject<T> | null,
  handler: TOnOutsideClickHandler,
) {
  useEffect(() => {
    const listener = (event: MouseEvent | TouchEvent) => {
      if (!ref || !ref.current || ref.current.contains(event.target as Node)) {
        return;
      }

      handler(event);
    };
    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
}
